import experimentsAvailableSelectorDefinition from './experiments-available.js'
import createExperimentEnabledSelectorDefinition from './create-experiment-enabled.js'
import createExperimentVariantSelectorDefinition from './create-experiment-variant.js'
import enabledExperimentsSelectorDefinition from './enabled-experiments.js'

const abTestingSelectors = [
  experimentsAvailableSelectorDefinition,
  enabledExperimentsSelectorDefinition,
  createExperimentVariantSelectorDefinition,
  createExperimentEnabledSelectorDefinition,
]

export default abTestingSelectors
